import logoWhite from "@assets/images/mandrake-logo-large-white.svg";
import useModalContext from "@contexts/modalContext";
import { Link, useNavigate } from "react-router-dom";
import BaseModal from "@elements/BaseModal";
import { Button } from "@mui/material";
import { useAuthContext } from "@contexts/authContext";
import styled from "@emotion/styled";
import { PiArrowLeftBold, PiArrowRightBold } from "react-icons/pi";
import { colors, fontSize, size } from "@styles/theme";
import { BackgroundImage } from "@components/auth/landing/LandingElements";

const NextStepsContainer = styled.div`
  position: relative;
  overflow: hidden;

  width: 90dvw;
  height: ${size(52)};

  border: 0.5px solid grey;
  border-radius: 30px;
`;

const SubscriptionContainerInner = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;

  height: 100%;
  width: 100%;
  padding: ${size(2.5)};
`;

const BottomArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
`;

const CapsuleArea = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  margin-bottom: ${size(1)};
`;

const Capsule = styled.div`
  padding: ${size(1)};
  border-radius: 100px;
  background-color: black;
  font-size: ${fontSize("sm")};
  margin-top: ${size(0.5)};
`;

const ButtonArea = styled.div`
  display: flex;
  flex-direction: column;
  // align-items: center;
  width: 100%;
`;

const SubscriptionFeature = () => {
  const { subscriptionFeature, registerUser } = useModalContext();
  const { state: authState } = useAuthContext();
  const navigate = useNavigate();

  const renderNextButton = () => {
    if (authState?.user?.isAnonymous)
      return (
        <Button
          variant="contained"
          style={{
            borderRadius: "100px",
            padding: size(1.5),
            marginBottom: size(1),
            background:
              "linear-gradient(172.5deg, #2293EE 23.12%, #751DE4 110%)",
          }}
          onClick={() => registerUser.open(null, { replace: true })}
        >
          Register Here&nbsp;
          <PiArrowRightBold />
        </Button>
      );
    else
      return (
        <Button
          component={Link}
          variant="contained"
          style={{
            borderRadius: "100px",
            padding: size(1.5),
            marginBottom: size(1),
            background:
              "linear-gradient(172.5deg, #2293EE 23.12%, #751DE4 110%)",
          }}
          to="/subscription"
        >
          See Supporter Plans&nbsp;
          <PiArrowRightBold />
        </Button>
      );
  };

  return (
    <BaseModal
      modalSlotProps={{
        backdrop: { style: { backgroundColor: "rgba(255,255,255,0.25)" } },
      }}
      open={subscriptionFeature.isOpen}
      setClosed={() => navigate(-1)}
      noAnimation
    >
      <NextStepsContainer>
        <BackgroundImage src="https://mandrake-app.b-cdn.net/dev/application/display_elements/display-background-2-480w.jpeg" />
        <SubscriptionContainerInner>
          <h1
            style={{
              textAlign: "center",
              lineHeight: size(3),
              fontSize: size(2.25),
              margin: `0 ${size(1)}`,
            }}
          >
            <img
              src={logoWhite}
              style={{ flexShrink: 0, height: "3rem", width: "3rem" }}
            />
            <br />
            Become a Supporter
            <br />
            to use this
          </h1>
          <p
            style={{
              textAlign: "center",
              fontSize: fontSize("sm"),
              lineHeight: size(2.5),
              margin: `${size(1)}`,
            }}
          >
            {/* 🐣 Mandrake is a new application<br /><br /> */}
            Our plans for <b>Supporters</b> include:{" "}
            <em>Travel Mode, Hidden Mode, and more.</em>
          </p>
          <BottomArea>
            <CapsuleArea>
              <Capsule
                style={{
                  backgroundColor:
                    colors.statusColors.browsing("lightRgba")(0.5),
                  border: `0.5px solid ${colors.statusColors.browsing(
                    "primary"
                  )}`,
                  fontWeight: "600",
                }}
              >
                $3.99/mo
              </Capsule>
              &nbsp;
              <Capsule
                style={{
                  backgroundColor:
                    colors.statusColors.right_now("lightRgba")(0.5),
                  border: `0.5px solid ${colors.statusColors.right_now(
                    "primary"
                  )}`,
                  fontWeight: "600",
                }}
              >
                $19.99/6m
              </Capsule>
              &nbsp;
              <Capsule
                style={{
                  backgroundColor:
                    colors.statusColors.chatting("lightRgba")(0.5),
                  border: `0.5px solid ${colors.statusColors.chatting(
                    "primary"
                  )}`,
                  fontWeight: "600",
                }}
              >
                $35/1y
              </Capsule>
            </CapsuleArea>
            <ButtonArea>
              {renderNextButton()}
              <Button
                variant="outlined"
                style={{
                  borderRadius: "100px",
                  padding: size(1.5),
                  border: "1px solid grey",
                  color: "white",
                }}
                onClick={() => navigate(-1)}
              >
                <PiArrowLeftBold />
                &nbsp;Exit
              </Button>
            </ButtonArea>
          </BottomArea>
        </SubscriptionContainerInner>
      </NextStepsContainer>
    </BaseModal>
  );
};

export default SubscriptionFeature;
